var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_c('common-uploader', _vm._b({ staticClass: "image-selector" }, 'common-uploader', _vm.uploaderAttrs, false), [_c('el-button', _vm._b({ staticClass: "upload-cover-button", attrs: { "loading": _vm.isUploading } }, 'el-button', _vm.buttonAttrs, false), [_vm._v(_vm._s(_vm.$t('playTurbo.custom.uploadCover')))])], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };